export function fileToByteArray(file: File): Promise<number[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const buffer = reader.result as ArrayBuffer;
      const byteArray = Array.from(new Uint8Array(buffer));
      resolve(byteArray);
    };
    reader.onerror = (error) => reject(error);
  });
}